module.exports = __webpack_public_path__ + "images/bancontact.01ef66c363ed438224f4193c2c206c90.png";